// extracted by mini-css-extract-plugin
export default {"navContent":"style_navContent__2+DIT","buttonBox":"style_buttonBox__N0T6f","box":"style_box__H-nxE"};